<template>
  <div>
    <div>
    <b-nav class="main-nav">
    <b-nav-item class="logo">
    <img src="../assets/img/logo.png"/>
    </b-nav-item>
    </b-nav>
    </div>
    <div>
    <div class="main-div">
    <div class="login-div">
    <div class="profile-div">
      <h5 class="mt-3 mb-3"> Webinar </h5><br>
      <b-card-group deck class="col-6 mx-auto">
       <b-card
         header="People Counting Webinar - 9th July 2020"
         header-tag="header"
         body-class="text-center"
       >
       <div class="wdiv">
         <b-embed
           type="iframe"
           aspect="16by9"
           src="https://www.youtube.com/embed/TT5sAOyvEKY"
         ></b-embed>
       </div>
     <b-card-text></b-card-text>
     <!-- <b-button v-bind:href=livePlugin target='_blank' variant="warning">Download Plugin</b-button>
     <b-button v-bind:href=liveUserDocument target='_blank' variant="warning">Download User Document</b-button> -->
   </b-card>
 </b-card-group>
    </div>
</div>
</div>
</div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';
import _ from 'lodash'

export default {
  name: 'webinar',
  components: { FacitHeader },
  data() {
    return {
      livePlugin: '',
      playbackPlugin: '',
      userDocument: '',
      liveUserDocument: '',
    };
  },
  created() {
    this.getDownloads();
},
  methods: {
    async getDownloads() {
      const downloads = await API.get('Downloads');
      const downloadsList = _.groupBy(downloads, 'name')
      this.livePlugin = downloadsList['Facit Milestone Identity Cloak Live Plugin'][0].link
      this.playbackPlugin = downloadsList['Facit Milestone Identity Cloak Plugin'][0].link
      this.userDocument = downloadsList['Facit Milestone Identity Cloak Plugin User Guide'][0].link
      this.liveUserDocument = downloadsList['Facit Milestone Video Redaction Live Plugin User Guide'][0].link
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
}
.main-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  margin: auto;
}

.login-div {
  background-color: white;
  width: 100%;
  height: 260px;
}
.logo {
  margin-top: 20px;
  margin-left: 30px;
}
.wdiv {
  width: 500px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/webinar.vue